import React from "react";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { ROLE_DEFAULT_ROUTES } from "../../../constants/auth";

const ChevronLeftIcon = ({ color }) => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none"
    stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="10 4 6 8 10 12" />
  </svg>
);

const BackToDashboard = () => {
  const theme          = useTheme();
  const t              = theme.custom;
  const navigate       = useNavigate();
  const { userRole }   = useAuth();
  const dashboardRoute = ROLE_DEFAULT_ROUTES[userRole] ?? "/login";

  return (
    <button
      onClick={() => navigate(dashboardRoute)}
      style={{
        display:      "inline-flex",
        alignItems:   "center",
        gap:          4,
        background:   "none",
        border:       "none",
        padding:      0,
        cursor:       "pointer",
        opacity:      0.55,
        transition:   "opacity .15s",
      }}
      onMouseEnter={e => (e.currentTarget.style.opacity = "1")}
      onMouseLeave={e => (e.currentTarget.style.opacity = "0.55")}
    >
      <ChevronLeftIcon color={t.text3} />
      <span style={{
        fontSize:      11,
        fontWeight:    600,
        letterSpacing: ".08em",
        textTransform: "uppercase",
        color:         t.text3,
      }}>
        Dashboard
      </span>
    </button>
  );
};

export default BackToDashboard;
